var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('header',[_c('div',{staticClass:"wrap"},[_c('a',{staticClass:"logo",attrs:{"href":"/servicemap"}})])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }